import { setSelectedKey } from '../State/selectedKey';

export default (selectedKeys: any) => async (dispatch) => {
  
  dispatch(setSelectedKey(selectedKeys[0]))
}